











































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { onlyFloat } from '@/utils/common'
import moment from 'moment'
import _ from 'lodash'

const SCROLL_CLOSE_DEBOUNCE_MS = 10

@Component
export default class ModalRegraValoresFixosIncluir extends Vue {
  $refs: {
    formValorFixo: any
    fontePagadoraSelect?: any
    prestadoresSelect?: any
    profissionalExecutanteSelect?: any
    grupoRepasseSelect?: any
    subGrupoRepasseSelect?: any
    centroDeCustoSelect?: any
    transacaoFinanceiraSelect?: any
    inicioVigenciaMenu?: any
    fimVigenciaMenu?: any
  }

  formRegraValoresFixosRule: any = {
    valid: true,
    valorFixo: [
      (v: any) =>
        (v !== null && v !== undefined && v !== '') || 'O valor é obrigatório.',
      (v: any) => {
        const num = parseFloat(String(v).replace(',', '.'))
        return (!isNaN(num) && num !== 0) || 'Valor não pode ser zero.'
      },
    ],
    descricao: [
      (v: any) => !!v || 'Descrição é obrigatória',
      (v: any) => !v || v.length <= 100 || 'Máximo de 100 caracteres',
    ],
    tipo: [
      (v: any) => !!v || 'Tipo é obrigatório',
      (v: any) => !v || v.length <= 50 || 'Máximo de 50 caracteres',
    ],
    fontePagadoraId: [
      (v: any) =>
        (v !== null && v !== undefined && v !== '') ||
        'A fonte pagadora é obrigatória.',
    ],
    prestadorId: [
      (v: any) =>
        (v !== null && v !== undefined && v !== '') ||
        'O prestador é obrigatório.',
    ],
    profissionalExecutanteId: [
      (v: any) =>
        (v !== null && v !== undefined && v !== '') ||
        'O profissional executante é obrigatório.',
    ],
    inicioVigencia: [
      (v: any) =>
        (v !== null && v !== undefined && v !== '') ||
        'A data de início da vigência é obrigatória.',
    ],
  }

  menuInicioVigencia: boolean = false
  menuFimVigencia: boolean = false
  attemptedSubmitValorFixo: boolean = false
  initialDataLoaded: boolean = false
  searchProfissional: any = ''
  profissionalName: string = ''
  loadingProfissionalFilter: boolean = false
  searchPrestador: any = ''
  loadingPrestadorFilter: boolean = false
  ignoreNextPrestadorSearch: boolean = false

  prestadoresDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getPrestadoresRepasse({ filtro: param, limite: 20 }), 500)

  profissionaisDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getProfissionais({nome: param, campo: 'modal'}), 500)

  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  get mode() {
    return this.getRegrasDeCalculoStore.modeModalRegraValoresFixos
  }

  loadAddRegraCalculo: boolean = false
  get loadingAddRegraCalculo() {
    return this.loadAddRegraCalculo
  }
  set loadingAddRegraCalculo(value: boolean) {
    this.loadAddRegraCalculo = value
  }

  get showModalRegraValoresFixosIncluir() {
    return this.getRegrasDeCalculoStore.modal.valoresFixosIncluir
  }
  set showModalRegraValoresFixosIncluir(value: boolean) {
    this.getRegrasDeCalculoStore.setModal({
      name: 'valoresFixosIncluir',
      value,
    })
  }

  get centroDeCusto() {
    return this.getRegrasDeCalculoStore.centroDeCusto
  }
  get transacaoFinanceira() {
    return this.getRegrasDeCalculoStore.transacaoFinanceira
  }
  get fontesPagadoras() {
    return this.getRegrasDeCalculoStore.fontesPagadoras
  }
  get profissionaisExecutantes() {
    return this.getRegrasDeCalculoStore.profissionaisExecutantesModal
  }
  get prestadores() {
    return this.getRegrasDeCalculoStore.prestadoresRepasse
  }
  set prestadores(value: any) {
    this.getRegrasDeCalculoStore.setPrestadoresRepasse(value)
  }
  get gruposRepasse() {
    return this.getRegrasDeCalculoStore.gruposRepasse
  }
  get subGruposRepasse() {
    return this.getRegrasDeCalculoStore.subGruposRepasse
  }

  get getMenuInicioVigencia() {
    return this.menuInicioVigencia
  }
  set getMenuInicioVigencia(value: boolean) {
    this.menuInicioVigencia = value
  }

  get getMenuFimVigencia() {
    return this.menuFimVigencia
  }
  set getMenuFimVigencia(value: boolean) {
    this.menuFimVigencia = value
  }

  get formattedInicioVigencia() {
    const { inicioVigencia } = this.getRegrasDeCalculoStore.regraValorFixoItem

    if (inicioVigencia) {
      return this.formatDate(inicioVigencia)
    }
    return ''
  }

  get inicioVigenciaErrors(): string[] {
    if (!this.attemptedSubmitValorFixo) return []
    return this.getRegrasDeCalculoStore.regraValorFixoItem.inicioVigencia
      ? []
      : ['A data de início da vigência é obrigatória.']
  }

  get formattedFimVigencia() {
    const { fimVigencia } = this.getRegrasDeCalculoStore.regraValorFixoItem
    
    if (fimVigencia) {
      return this.formatDate(fimVigencia)
    }
    return ''
  }

  get selectedProfissionalExecutante(){
    return this.getRegrasDeCalculoStore.regraValorFixoItem.profissionalExecutanteId
  }

  set selectedProfissionalExecutante(value: any){
    if(value) this.getRegrasDeCalculoStore.regraValorFixoItem.profissionalExecutanteId = value.userId ? value.userId : value
  }

  updateFimVigencia(date: string) {
    this.getRegrasDeCalculoStore.regraValorFixoItem.fimVigencia = date
  }

  updateInicioVigencia(date: string) {
    this.getRegrasDeCalculoStore.regraValorFixoItem.inicioVigencia = date
  }

  formatDate(vigencia: any) {
    const date = new Date(vigencia)
    if (!Number.isNaN(date.getTime())) {
      const day = String(date.getUTCDate()).padStart(2, '0')
      const month = String(date.getUTCMonth() + 1).padStart(2, '0')
      const year = date.getUTCFullYear()
      return `${day}/${month}/${year}`
    }
    console.error('Data inválida:', vigencia)
    return ''
  }

  displayDateAndHours(value: any) {
    if (['', null, undefined].includes(value)) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  onlyFloatUtil(value: number) {
    return onlyFloat(value)
  }

  async addValorFixo() {
    this.attemptedSubmitValorFixo = true
    const isValid = await this.$refs.formValorFixo.validate()
    if (!isValid || this.inicioVigenciaErrors.length > 0) {
      this.loadingAddRegraCalculo = false
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Preencha todos os campos obrigatórios corretamente.',
        icon: 'warning',
        color: '#C62828',
      })
      return
    }
    this.loadingAddRegraCalculo = true
    const request = await this.getRegrasDeCalculoStore.addValorFixo()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1f615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAddRegraCalculo = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Regra incluída com sucesso. ${String.fromCodePoint(0x1f642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingAddRegraCalculo = false
    this.closeModal()
  }

  onGrupoRepasseChange(value: string) {
    this.getRegrasDeCalculoStore.getSubGruposRepasse(value)
  }

  closeModal() {
    this.showModalRegraValoresFixosIncluir = false
    this.getRegrasDeCalculoStore.clearRegraValorFixoItem()
    this.$refs.formValorFixo.resetValidation()
    this.attemptedSubmitValorFixo = false
  }

  changeProfissionalExecutante(value) {
    if(value){
      this.profissionalName = value.nome
      this.selectedProfissionalExecutante = value.userId
    } else {
      this.profissionalName = ''
    }
  }

  onChangePrestador() {
    this.ignoreNextPrestadorSearch = true
  }
  
  resetField(field: string) {
    const item = this.getRegrasDeCalculoStore.regraValorFixoItem
    item[field] = ''
  }

  @Watch('showModalRegraValoresFixosIncluir')
  async onChangeShowModalAddRegraValoresFixosIncluir(value: boolean) {
    if (!value) {
      this.getRegrasDeCalculoStore.clearRegraValorFixoItem()
      this.$refs.formValorFixo.resetValidation()
      this.attemptedSubmitValorFixo = false
    } else {
      const item = this.getRegrasDeCalculoStore.regraValorFixoItem
      if(item.profissionalExecutanteId){
        this.getRegrasDeCalculoStore.setProfissionaisExecutantesModal([{
          userId: item.profissionalExecutanteId,
          nome: item.profissionalNome
        }])
        this.selectedProfissionalExecutante = item.profissionalExecutanteId
        this.profissionalName = item.profissionalNome
      }
      
      if (!this.initialDataLoaded) {
        await this.getRegrasDeCalculoStore.getFontesPagadoras()
        await this.getRegrasDeCalculoStore.getCentroDeCusto()
        await this.getRegrasDeCalculoStore.getGruposRepasse()
        await this.getRegrasDeCalculoStore.getTransacaoFinanceiraFixo()
        this.initialDataLoaded = true
      }

      this.prestadores = [{
        userId: this.getRegrasDeCalculoStore.regraValorFixoItem.prestadorId,
        nome: this.getRegrasDeCalculoStore.regraValorFixoItem.prestadorNome
      }]

    }
  }

  @Watch('searchProfissional')
    async onSearchProfissionalChanged(val: string) {
      if (!val || val.length < 3){
        this.getRegrasDeCalculoStore.setProfissionaisExecutantesModal([])
        this.getRegrasDeCalculoStore.regraValorFixoItem.profissionalExecutanteId = ''
        return
      }
  
      if(this.profissionalName === val){
        return
      } else {
        this.getRegrasDeCalculoStore.regraValorFixoItem.profissionalExecutanteId = ''
      }
      
      this.loadingProfissionalFilter = true
      if(this.profissionaisDebounced) await this.profissionaisDebounced(val)
      this.loadingProfissionalFilter = false
    }

  @Watch('searchPrestador')
  async onSearchPrestadorChanged(val: string) {
    if (this.ignoreNextPrestadorSearch) {
      this.ignoreNextPrestadorSearch = false
      return
    }

    if (!val || val.length < 3) {
      this.getRegrasDeCalculoStore.setPrestadoresRepasse([])
      this.getRegrasDeCalculoStore.regraValorFixoItem.prestadorId = ''
      return
    }

    this.loadingPrestadorFilter = true
    if (this.prestadoresDebounced) await this.prestadoresDebounced(val)
    this.loadingPrestadorFilter = false
  }

  async mounted() {
    this.addScrollCloseListener()
  }

  beforeDestroy() {
    this.removeScrollCloseListener()
  }

  addScrollCloseListener() {
    let timer: any = null
    const handler = (ev: Event) => {
      try {
        const target = ev.target as HTMLElement | null
        const isInsideMenu = (el: any) =>
          !!(el && el.closest && el.closest('.v-menu__content'))
        if (target && isInsideMenu(target)) return
        const anyEv: any = ev as any
        if (anyEv.composedPath && typeof anyEv.composedPath === 'function') {
          const path: any[] = anyEv.composedPath()
          if (
            path &&
            path.some(
              (n: any) =>
                n &&
                n.classList &&
                n.classList.contains &&
                n.classList.contains('v-menu__content')
            )
          ) {
            return
          }
        }
      } catch {}
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => {
        try {
          this.closeAllSelects()

          const openMenus = Array.from(
            document.querySelectorAll('.v-menu__content')
          ) as HTMLElement[]
          const hasActiveMenu = openMenus.some(
            (m) =>
              m.classList.contains('menuable__content__active') ||
              m.classList.contains('v-menu__content--active') ||
              m.style.display !== 'none'
          )
          if (hasActiveMenu) {
            const esc = new KeyboardEvent('keydown', {
              key: 'Escape',
              code: 'Escape',
              bubbles: true,
              cancelable: true,
            })
            document.dispatchEvent(esc)
          }

          const focusedAuto = document.querySelector(
            '.v-autocomplete.v-input--is-focused input'
          ) as HTMLElement | null
          if (focusedAuto) focusedAuto.blur()

          const active = document.activeElement as HTMLElement | null
          if (active && ['INPUT', 'TEXTAREA'].includes(active.tagName)) {
            active.blur()
          }
        } catch (e) {}
      }, SCROLL_CLOSE_DEBOUNCE_MS)
    }
    window.addEventListener('scroll', handler as EventListener, {
      passive: true,
    })
    window.addEventListener('wheel', handler as EventListener, {
      passive: true,
    })
    window.addEventListener('touchmove', handler as EventListener, {
      passive: true,
    })

    const modalContent = document.querySelector(
      '.modal-regra-de-calculo'
    ) as HTMLElement | null
    const targets: Array<HTMLElement | Window> = [window]
    if (modalContent) {
      const addAll = (el: HTMLElement) => {
        el.addEventListener('scroll', handler as EventListener, {
          passive: true,
        })
        el.addEventListener('wheel', handler as EventListener, {
          passive: true,
        })
        el.addEventListener('touchmove', handler as EventListener, {
          passive: true,
        })
        targets.push(el)
      }
      addAll(modalContent)
      const candidates = modalContent.querySelectorAll(
        '.v-card__text, .v-card, .v-sheet'
      )
      candidates.forEach((el) => addAll(el as HTMLElement))
    }
    ;(this as any)._scrollCloseHandler = handler
    ;(this as any)._scrollCloseTargets = targets
  }

  removeScrollCloseListener() {
    const handler = (this as any)._scrollCloseHandler
    const targets: Array<HTMLElement | Window> =
      (this as any)._scrollCloseTargets || []
    if (handler) {
      targets.forEach((t) => {
        ;(t as any).removeEventListener &&
          (t as any).removeEventListener('scroll', handler)
        ;(t as any).removeEventListener &&
          (t as any).removeEventListener('wheel', handler)
        ;(t as any).removeEventListener &&
          (t as any).removeEventListener('touchmove', handler)
      })
      ;(this as any)._scrollCloseTargets = []
      ;(this as any)._scrollCloseHandler = null
    }
  }

  private closeAllSelects() {
    try {
      const refNames = [
        'fontePagadoraSelect',
        'prestadoresSelect',
        'profissionalExecutanteSelect',
        'grupoRepasseSelect',
        'subGrupoRepasseSelect',
        'centroDeCustoSelect',
        'transacaoFinanceiraSelect',
      ] as const
      refNames.forEach((name) => {
        const refAny: any = (this.$refs as any)[name]
        const closeInstance = (inst: any) => {
          if (!inst) return
          if (typeof inst.isMenuActive !== 'undefined')
            inst.isMenuActive = false
          if (
            inst.$refs &&
            inst.$refs.input &&
            typeof inst.$refs.input.blur === 'function'
          ) {
            try {
              inst.$refs.input.blur()
            } catch {}
          }
        }
        if (Array.isArray(refAny)) refAny.forEach(closeInstance)
        else closeInstance(refAny)
      })
    } catch {}
  }
}
